<div mat-dialog-content>
    <div class="mainDiv">
           <p mat-dialog-title style="margin: 0 0 10px; width: 400px;font-size: 16px;">Why are you removing this blog, please mention the reason below.</p>
           <!-- <form [formGroup]="removeform"> -->
               
       <textarea type="text" placeholder="Remark" required  formControlName="Remark"  maxlength="100" rows="3"style="width: 100%;"></textarea>
       <!-- <mat-error *ngIf="marketrateform1.get('Remark').hasError('required')">
                        Please write valid reason.
       </mat-error> -->
        <div style="float: right;margin-top: 10px;margin-bottom: 13px;">
            <button type="submit" mat-button  style="margin-right: 5px;" class="btn btncls" (click)="onSubmit()">Submit</button>
            <button mat-button class="btn btncls" (click)="onNoClick()">Cancel</button>
     </div>
      <!-- </form> -->
    </div>
</div>
<style>
.btncls{
  width:100px;
  color: white;
  background-color: #234a90;
}

.mainDiv{
  padding: 10px 20px 10px 20px;
}
textarea {
  resize: none;
}
</style>